import { useDataValue } from 'Simple/Data.js'
import useStableValue from 'Logic/useStableValue.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props) {
  let search_term = useStableValue(
    useDataValue({
      viewPath: props.viewPath,
      context: 'tags_picker',
      path: 'search_term',
    })
  )

  let tags = useDataValue({
    context: 'event_action',
    path: 'data.tags',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      or: [
        { name: { _ilike: `%${search_term || ''}%` } },
        ...(!search_term && tags.length
          ? [{ id: { _in: tags.map(tag => tag.id) } }]
          : []),
      ],
    },
    requestPolicy: 'cache-and-network',
  }
}
